import Vue from 'vue'
import Vuex from 'vuex'

// Stores
import header from '@/store/header'
import navigation from '@/store/navigation'
import sidebar from '@/store/sidebar'
import page from '@/store/page'
import modal from '@/store/modal'

Vue.use(Vuex)

const state = {}

const mutations = {}

const actions = {}

const modules = {
  header,
  navigation,
  sidebar,
  page,
  modal
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  modules
})

export default store
